export const exampleData = [
  {
    Name: 'Used Car',
    AggregateMetric: {
      TimePeriod: 'Last12Months',
      AverageSearchVolume: 4550,
      AverageCPC: 1000,
      CompetitionLevel: 'Low',
    },
    Suggestions: [
      {
        Keyword: 'carvana used cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Used Car',
        Existing: true,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 308,
          AverageCPC: 1000,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'carvana used cars inventory',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Used Car',
        Existing: true,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 50,
          AverageCPC: 230,
          CompetitionLevel: 'High',
        },
      },
      {
        Keyword: 'edmunds used cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Used Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 50,
          AverageCPC: 30,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'truecar used cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Used Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 40,
          AverageCPC: 40,
          CompetitionLevel: 'High',
        },
      },
      {
        Keyword: 'used cars near me',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Used Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 80,
          AverageCPC: 0,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'used cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Used Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 40,
          AverageCPC: 860,
          CompetitionLevel: 'High',
        },
      },
      {
        Keyword: 'autotrader used cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Used Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 80,
          AverageCPC: 901,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'certified used cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Used Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 60,
          AverageCPC: 3330,
          CompetitionLevel: 'High',
        },
      },
      {
        Keyword: 'cargurus used cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Used Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 990,
          AverageCPC: 2220,
          CompetitionLevel: 'High',
        },
      },
      {
        Keyword: 'cars com used cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Used Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 880,
          AverageCPC: 1110,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'buy used cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Used Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 770,
          AverageCPC: 340,
          CompetitionLevel: 'High',
        },
      },
      {
        Keyword: 'kelley blue book used cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Used Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 550,
          AverageCPC: 10,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'carmax used cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Used Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 660,
          AverageCPC: 20,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'carfax used cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Used Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 440,
          AverageCPC: 30,
          CompetitionLevel: 'High',
        },
      },
      {
        Keyword: 'bmw used cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Used Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 580,
          AverageCPC: 900,
          CompetitionLevel: 'Medium',
        },
      },
      {
        Keyword: 'blue book value used cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Used Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 320,
          AverageCPC: 102,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'evans halshaw used cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Used Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 120,
          AverageCPC: 320,
          CompetitionLevel: 'Medium',
        },
      },
      {
        Keyword: 'used cars ni',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Used Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 350,
          AverageCPC: 30,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'arnold clark used cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Used Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 230,
          AverageCPC: 40,
          CompetitionLevel: 'Medium',
        },
      },
    ],
  },
  {
    Name: 'Car',
    AggregateMetric: {
      TimePeriod: 'Last12Months',
      AverageSearchVolume: 450,
      AverageCPC: 330,
      CompetitionLevel: 'Low',
    },
    Suggestions: [
      {
        Keyword: 'new cars 2020',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Car',
        Existing: true,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 1230,
          AverageCPC: 130,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'honda cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Car',
        Existing: true,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 850,
          AverageCPC: 530,
          CompetitionLevel: 'Medium',
        },
      },
      {
        Keyword: 'pre owned cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 150,
          AverageCPC: 630,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'suv cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 9814,
          AverageCPC: 220,
          CompetitionLevel: 'Medium',
        },
      },
      {
        Keyword: 'jaguar cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 465,
          AverageCPC: 330,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'disney cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 123,
          AverageCPC: 440,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'cazoo cars uk',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 342,
          AverageCPC: 770,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'model cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 220,
          AverageCPC: 60,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'volvo cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 330,
          AverageCPC: 10,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'cars trucks',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 230,
          AverageCPC: 10,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'tesla 1 million cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 980,
          AverageCPC: 50,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'electric cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 608,
          AverageCPC: 60,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'mclaren cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 6850,
          AverageCPC: 90,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'cars film 2006',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 5550,
          AverageCPC: 100,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'lowrider cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 6660,
          AverageCPC: 960,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'sports cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 60,
          AverageCPC: 9690,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'japan gas powered cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 70,
          AverageCPC: 567890,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'gateway classic cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 30,
          AverageCPC: 3333,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'motability cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 50,
          AverageCPC: 456,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: '2020 new cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 1230,
          AverageCPC: 9999,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'luxury cars',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Car',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 77770,
          AverageCPC: 11100,
          CompetitionLevel: 'Low',
        },
      },
    ],
  },
  {
    Name: 'Used Car Sale',
    AggregateMetric: {
      TimePeriod: 'Last12Months',
      AverageSearchVolume: 9990,
      AverageCPC: 8850,
      CompetitionLevel: 'Low',
    },
    Suggestions: [
      {
        Keyword: 'used cars sale near me',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Used Car Sale',
        Existing: true,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 88880,
          AverageCPC: 9620,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'used cars sale',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Used Car Sale',
        Existing: true,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 808,
          AverageCPC: 4210,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'cheap used cars sale',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Used Car Sale',
        Existing: true,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 90,
          AverageCPC: 6250,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'used cars sale my area',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Used Car Sale',
        Existing: true,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 30,
          AverageCPC: 8550,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'used cars sale owner',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Used Car Sale',
        Existing: true,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 502,
          AverageCPC: 6230,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'used cars sales',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Used Car Sale',
        Existing: true,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 560,
          AverageCPC: 10000,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'all used cars sale',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Used Car Sale',
        Existing: true,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 230,
          AverageCPC: 60,
          CompetitionLevel: 'Low',
        },
      },
    ],
  },
  {
    Name: 'Car Sale',
    AggregateMetric: {
      TimePeriod: 'Last12Months',
      AverageSearchVolume: 3890,
      AverageCPC: 3330,
      CompetitionLevel: 'Low',
    },
    Suggestions: [
      {
        Keyword: 'cars sale near me',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Car Sale',
        Existing: true,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 40,
          AverageCPC: 10,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'cars sale',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Car Sale',
        Existing: true,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 30,
          AverageCPC: 20,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'cars sale my area',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Car Sale',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 20,
          AverageCPC: 30,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'new cars sale',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Car Sale',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 120,
          AverageCPC: 40,
          CompetitionLevel: 'Low',
        },
      },
      {
        Keyword: 'cars sale owner',
        SourceType: 'SuggestionFromKeyword',
        Tag: 'Car Sale',
        Existing: false,
        AggregateMetric: {
          TimePeriod: 'Last12Months',
          AverageSearchVolume: 120,
          AverageCPC: 560,
          CompetitionLevel: 'Low',
        },
      },
    ],
  },
];

export const searchIdeaExampleData = [{
  Aggregations: [{
    Keywords: [{
      Type: 'Idea',
      Index: 0,
      Keyword: {
        Text: 'abcdefghi',
        MatchType: 'Broad',
      },
    }],
  }],
}];
